"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.targets = exports.isTarget = exports.isClient = exports.addTargetClient = exports.addTarget = exports.isHarEntry = exports.HTTPSnippet = exports.extname = exports.availableTargets = exports.getHeaderName = exports.getHeader = exports.escapeString = exports.CodeBuilder = void 0;
var code_builder_1 = require("./helpers/code-builder");
__createBinding(exports, code_builder_1, "CodeBuilder");
var escape_1 = require("./helpers/escape");
__createBinding(exports, escape_1, "escapeString");
var headers_1 = require("./helpers/headers");
__createBinding(exports, headers_1, "getHeader");
__createBinding(exports, headers_1, "getHeaderName");
var utils_1 = require("./helpers/utils");
__createBinding(exports, utils_1, "availableTargets");
__createBinding(exports, utils_1, "extname");
var httpsnippet_1 = require("./httpsnippet");
__createBinding(exports, httpsnippet_1, "HTTPSnippet");
__createBinding(exports, httpsnippet_1, "isHarEntry");
var targets_1 = require("./targets/targets");
__createBinding(exports, targets_1, "addTarget");
__createBinding(exports, targets_1, "addTargetClient");
__createBinding(exports, targets_1, "isClient");
__createBinding(exports, targets_1, "isTarget");
__createBinding(exports, targets_1, "targets");
//# sourceMappingURL=index.js.map